/* eslint-disable no-param-reassign */

/* eslint-disable max-len */
import produce from "immer";

import {
  GET_OPERATION_FAILURE,
  GET_OPERATION_REQUEST,
  GET_OPERATION_SUCCESS
} from "src/actions/operationAction";

const initialState = {
  operations: [],
  loading: false,
  total: 0
};

const operationReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_OPERATION_REQUEST: {
      return produce(state, (draft) => {
        draft.operations = [];
        draft.loading = true;
      });
    }

    case GET_OPERATION_SUCCESS: {
      const {response, total} = action.payload;
      return produce(state, (draft) => {
        draft.operations = response;
        draft.loading = false;
        draft.total = total;
      });
    }

    case GET_OPERATION_FAILURE: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }

    default: {
      return state;
    }
  }
};

export default operationReducer;
